(ns frontend.view.entity-viewers.modules.entity-esign.signatory.view
  (:require
   [common.localization :as loc]
   [frontend.utils :as fu]
   [frontend.view.entity-viewers.modules.entity-esign.status-tag.view :as status-tag]
   [ui.components.button.view :as button]))

(defn view
  [{:keys [signatory-name email signed? last-reminded-on processing? on-remind]}]
  [:div
   {:class "flex justify-between items-center m-2 w-full"}
   [:div
    {:class "flex flex-col gap-1"}
    [:div
     {:class "m-0 text-sm"}
     signatory-name]
    [:div
     {:class "text-xs"}
     email]
    (when (and (not signed?) last-reminded-on)
      [:div
       {:class "mt-1"}
       (loc/tr :last-reminded-on [(fu/display-date-timestamp last-reminded-on)])])]
   (if signed?
     [:div
      {:class "py-px"}
      [status-tag/view
       {:label (loc/tr :signed)
        :variant :success}]]
     [button/sm-secondary-hollow
      {:on-click on-remind
       :disabled? processing?}
      (if-not processing?
        [:span (if last-reminded-on
                 (loc/tr :remind-again)
                 (loc/tr :remind))]
        [:span (loc/tr :sending)
         [:i.fal.fa-spinner.fa-pulse.ml-3]])])])

